// Copyright Epic Games, Inc. All Rights Reserved.

import { Actions } from "../actions";
import { SET_MAIN_SERVICE_ACCESS_TOKEN } from "./actions";

export const sharedFeatureStoreKey = "shared";
export interface ISharedAppState {
  mainServiceAccessToken: string;
}

export const initialSharedState: ISharedAppState = {
  mainServiceAccessToken: "",
};

export function sharedReducer(
  state: ISharedAppState = initialSharedState,
  action: Actions
): ISharedAppState {
  switch (action.type) {
    case SET_MAIN_SERVICE_ACCESS_TOKEN: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}
